/**
 * @generated SignedSource<<1de0b1fa13dad912e36377a4901e292c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
export type EventSignUpStatus = "CONFIRMED" | "DRAFT";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryTotal_signUp$data = {
  readonly event: {
    readonly id: string;
    readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  };
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly status: OrderStatus | null | undefined;
        readonly total: number | null | undefined;
        readonly totalTaxes: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly registrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly primaryChargeType: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly displayName: string | null | undefined;
          };
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly status: EventSignUpStatus;
  readonly " $fragmentType": "EventSignupSummaryTotal_signUp";
};
export type EventSignupSummaryTotal_signUp$key = {
  readonly " $data"?: EventSignupSummaryTotal_signUp$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryTotal_signUp">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryTotal_signUp",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryChargeType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "EventRegistrationConnection",
      "kind": "LinkedField",
      "name": "registrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationChargeType",
                  "kind": "LinkedField",
                  "name": "primaryChargeType",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ChargeRuleSet",
                      "kind": "LinkedField",
                      "name": "chargeRuleSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 1
                            }
                          ],
                          "concreteType": "ChargeRuleConnection",
                          "kind": "LinkedField",
                          "name": "chargeRules",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ChargeRuleEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ChargeRule",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "price",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "chargeRules(first:1)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "registrations(first:50)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": true
        }
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "total",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalTaxes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orders(active:true)"
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "ae28a068918e01385f21e2a0724b69c1";

export default node;
